/** Keep a consumed OTP's result in memory while the app commits the session. */
export function createOtpLoginAttempt() {
    let pending = false;
    let completed = false;
    let verifiedSession = null;
    return {
        get pending() { return pending; },
        async submit(args) {
            if (pending || completed)
                return;
            pending = true;
            try {
                if (!verifiedSession) {
                    const session = await args.verify();
                    if (!session)
                        return;
                    // Retain only session fields, never the phone or OTP.
                    verifiedSession = {
                        access_token: session.access_token,
                        refresh_token: session.refresh_token,
                    };
                    args.onVerified();
                }
                await args.finalize(verifiedSession);
                completed = true;
                verifiedSession = null;
            }
            finally {
                pending = false;
            }
        },
    };
}
